module.exports = __webpack_public_path__ + "static/media/green-co.964538b6.png";